export const recursiveBillingSetupConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        setMaster_request: "setMaster_request",
        setMaster_success: "setMaster_success",
        setMaster_failure: "setMaster_failure",

        addAccount_request: "addAccount_request",
        addAccount_success: "addAccount_success",
        addAccount_failure: "addAccount_failure",

        addMultiAccount_request: "addMultiAccount_request",
        addMultiAccount_success: "addMultiAccount_success",
        addMultiAccount_failure: "addMultiAccount_failure",

        deleteAccount_request: "deleteAccount_request",
        deleteAccount_success: "deleteAccount_success",
        deleteAccount_failure: "deleteAccount_failure",

        deactivateAccount_request: "deactivateAccount_request",
        deactivateAccount_success: "deactivateAccount_success",
        deactivateAccount_failure: "deactivateAccount_failure",

        updateAccount_request: "updateAccount_request",
        updateAccount_success: "updateAccount_success",
        updateAccount_failure: "updateAccount_failure",

        getExistingDealerCodeList_request: "getExistingDealerCodeList_request",
        getExistingDealerCodeList_success: "getExistingDealerCodeList_success",
        getExistingDealerCodeList_failure: "getExistingDealerCodeList_failure",

        getExistingSalesPersonCodeList_request: "getExistingSalesPersonCodeList_request",
        getExistingSalesPersonCodeList_success: "getExistingSalesPersonCodeList_success",
        getExistingSalesPersonCodeList_failure: "getExistingSalesPersonCodeList_failure",

        updateDealerCode_request: "updateDealerCode_request",
        updateDealerCode_success: "updateDealerCode_success",
        updateDealerCode_failure: "updateDealerCode_failure",

        updateSalesPersonCode_request: "updateSalesPersonCode_request",
        updateSalesPersonCode_success: "updateSalesPersonCode_success",
        updateSalesPersonCode_failure: "updateSalesPersonCode_failure",
        
        getAllBillingSetup_request: "getAllBillingSetup_request",
        getAllBillingSetup_success: "getAllBillingSetup_success",
        getAllBillingSetup_failure: "getAllBillingSetup_failure",
        
        getBillingSetup_request: "getBillingSetup_request",
        getBillingSetup_success: "getBillingSetup_success",
        getBillingSetup_failure: "getBillingSetup_failure",
        
        getUnbillBillingSetup_request: "getUnbillBillingSetup_request",
        getUnbillBillingSetup_success: "getUnbillBillingSetup_success",
        getUnbillBillingSetup_failure: "getUnbillBillingSetup_failure",

        getNonautomatedAccountList_request: "getNonautomatedAccountList_request",
        getNonautomatedAccountList_success: "getNonautomatedAccountList_success",
        getNonautomatedAccountList_failure: "getNonautomatedAccountList_failure",

        getAutomatedAccountList_request: "getAutomatedAccountList_request",
        getAutomatedAccountList_success: "getAutomatedAccountList_success",
        getAutomatedAccountList_failure: "getAutomatedAccountList_failure",

        removeAutomatedAccounts_request: "removeAutomatedAccounts_request",
        removeAutomatedAccounts_success: "removeAutomatedAccounts_success",
        removeAutomatedAccounts_failure: "removeAutomatedAccounts_failure",

        addAutomatedAccounts_request: "addAutomatedAccounts_request",
        addAutomatedAccounts_success: "addAutomatedAccounts_success",
        addAutomatedAccounts_failure: "addAutomatedAccounts_failure",

        deleteAllBillingSetup_request: "deleteAllBillingSetup_request",
        deleteAllBillingSetup_success: "deleteAllBillingSetup_success",
        deleteAllBillingSetup_failure: "deleteAllBillingSetup_failure",

        importMassBillingSetup_request: "importMassBillingSetup_request",
        importMassBillingSetup_success: "importMassBillingSetup_success",
        importMassBillingSetup_failure: "importMassBillingSetup_failure",

        getRemarks_request: "getRemarks_request",
        getRemarks_success: "getRemarks_success",
        getRemarks_failure: "getRemarks_failure",

        updateRemarks_request: "updateRemarks_request",
        updateRemarks_success: "updateRemarks_success",
        updateRemarks_failure: "updateRemarks_failure",

        getFullAgentCodeList_request: "getFullAgentCodeList_request",
        getFullAgentCodeList_success: "getFullAgentCodeList_success",
        getFullAgentCodeList_failure: "getFullAgentCodeList_failure",

        getFullProductDetailList_request: "getFullProductDetailList_request",
        getFullProductDetailList_success: "getFullProductDetailList_success",
        getFullProductDetailList_failure: "getFullProductDetailList_failure",

        getFullProductDetail_request: "getFullProductDetail_request",
        getFullProductDetail_success: "getFullProductDetail_success",
        getFullProductDetail_failure: "getFullProductDetail_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.recursiveBillingSetup/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}